import type { GoogleAnalyticsSendEventDataType } from '../types';

// TODO: Fix Property dataLayer does not exist on type Window & typeof globalThis
// declare global {
//   interface Window {
//     dataLayer?: unknown[];
//   }
// }

export function sendEvent({
  name,
  parameters
}: GoogleAnalyticsSendEventDataType) {
  // Отправка в GA4 и GTM
  if (typeof window.gtag === 'function') {
    window.gtag('event', name, parameters);
    return;
  }

  // Отправка в GTM
  if (window.dataLayer && Array.isArray(window.dataLayer)) {
    window.dataLayer.push({
      event: name,
      ...parameters
    });
  }
}
